import RavenjsError from 'ravenjs/lib/Error';

/**
 * Data Error class, when data is not present.
 *
 * @class
 * @extends RavenjsError
 */
class DataError extends RavenjsError {
    constructor(message = 'Data not present!') {
        super(message);
    }
}

export default DataError;
